import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

import Wrapper from 'components/wrapper';
import { UsersNav } from 'components/admin';

import CreateNewUserPage from './CreateNewUser';
import UserDetailPage from './UserDetail';
import UsersListPage from './UsersList';

const useStyles = makeStyles((theme) => ({
  title: {
    margin: theme.spacing(2.5, 0),
    fontSize: '1.25rem',
    fontWeight: '500',
  },
}));

const UsersPage = () => {
  const classes = useStyles();
  const location = useLocation();

  return (
    <Wrapper>
      <Typography className={classes.title}>
        Tucci Learning Solutions
      </Typography>
      <UsersNav pathname={location.pathname} />
      <Routes>
        <Route path='' exact element={<UsersListPage />} />
        <Route path='new' element={<CreateNewUserPage />} />
        <Route path=':id' element={<UserDetailPage />} />
      </Routes>
    </Wrapper>
  );
};

export default UsersPage;
